import { Injectable } from '@angular/core';
import { WefitSsoService } from '../sso/wefit-sso.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WefitNavigationService {

  constructor(
    private wefitSsoSrv: WefitSsoService
  ) {}

  /**
   * Redirige vers une page WeFit en injectant le token SSO.
   * Utilise l'URL retournée par l'API SSO (marque blanche), sinon l'endpoint de l'environnement.
   * @param path Chemin de la page WeFit (depuis WEFIT_PAGES), vide = page d'accueil
   */
  async goToPage(path: string = ''): Promise<void> {
    const [token, ssoUrl] = await Promise.all([
      this.wefitSsoSrv.getToken(),
      this.wefitSsoSrv.getSsoUrl(),
    ]);
    const normalizedBase = (ssoUrl || environment.wefitEndpoint).replace(/\/$/, '');
    const fullPath = path ? `${normalizedBase}/${path}` : normalizedBase;
    const url = token ? `${fullPath}?token=${encodeURIComponent(token)}` : fullPath;
    window.location.href = url;
  }

  /**
   * Redirige vers une formation WeFit spécifique (mode LMS2).
   * @param formationId ID de la formation (f_id)
   */
  async goToFormation(formationId: number): Promise<void> {
    const [token, ssoUrl] = await Promise.all([
      this.wefitSsoSrv.getToken(),
      this.wefitSsoSrv.getSsoUrl(),
    ]);
    const normalizedBase = (ssoUrl || environment.wefitEndpoint).replace(/\/$/, '');
    const url = token
      ? `${normalizedBase}/index.cfm?f_id=${formationId}&token=${encodeURIComponent(token)}`
      : `${normalizedBase}/index.cfm?f_id=${formationId}`;

    window.location.href = url;
  }
}
